import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["title", "icon", "danger"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { Item } from 'rc-menu';
import PropTypes from 'prop-types';
import toArray from 'rc-util/lib/Children/toArray';
import classNames from 'classnames';
import MenuContext from './config-provider/MenuContext';
import Tooltip from '../../wui-tooltip/src';
import { isValidElement, cloneElement } from './_util/reactNode';
var RcMenuItemProps = Item.propTypes;

var MenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MenuItem, _React$Component);

  var _super = _createSuper(MenuItem);

  function MenuItem() {
    _classCallCheck(this, MenuItem);

    return _super.apply(this, arguments);
  }

  _createClass(MenuItem, [{
    key: "renderItemChildren",
    value: function renderItemChildren(inlineCollapsed) {
      var _this$props = this.props,
          icon = _this$props.icon,
          children = _this$props.children,
          level = _this$props.level,
          rootPrefixCls = _this$props.rootPrefixCls; // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span

      if (!icon || isValidElement(children) && children.type === 'span') {
        if (children && inlineCollapsed && level === 1 && typeof children === 'string') {
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(rootPrefixCls, "-inline-collapsed-noicon")
          }, children.charAt(0));
        }

        return children;
      }

      return /*#__PURE__*/React.createElement("span", null, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          level = _this$props2.level,
          className = _this$props2.className,
          children = _this$props2.children,
          rootPrefixCls = _this$props2.rootPrefixCls;

      var _this$props3 = this.props,
          title = _this$props3.title,
          icon = _this$props3.icon,
          danger = _this$props3.danger,
          rest = _objectWithoutProperties(_this$props3, _excluded);

      return /*#__PURE__*/React.createElement(MenuContext.Consumer, null, function (_ref) {
        var _classNames;

        var inlineCollapsed = _ref.inlineCollapsed,
            direction = _ref.direction;
        var tooltipTitle = title;

        if (typeof title === 'undefined') {
          tooltipTitle = level === 1 ? children : '';
        } else if (title === false) {
          tooltipTitle = '';
        }

        var tooltipProps = {
          title: tooltipTitle
        }; // if (!siderCollapsed && !inlineCollapsed) {

        if (!inlineCollapsed) {
          tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct

          tooltipProps.visible = false;
        }

        var childrenLength = toArray(children).length;
        return /*#__PURE__*/React.createElement(Tooltip, _extends({}, tooltipProps, {
          placement: direction === 'rtl' ? 'left' : 'right',
          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
        }), /*#__PURE__*/React.createElement(Item, _extends({}, rest, {
          className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(rootPrefixCls, "-item-danger"), danger), _defineProperty(_classNames, "".concat(rootPrefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _classNames), className),
          title: title
        }), cloneElement(icon, {
          className: classNames(isValidElement(icon) ? icon.props.className : '', "".concat(rootPrefixCls, "-item-icon"))
        }), _this.renderItemChildren(inlineCollapsed)));
      });
    }
  }]);

  return MenuItem;
}(React.Component);

_defineProperty(MenuItem, "propTypes", _objectSpread(_objectSpread({}, RcMenuItemProps), {}, {
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  danger: PropTypes.bool,
  title: PropTypes.node,
  attribute: PropTypes.object
}));

_defineProperty(MenuItem, "defaultProps", {
  danger: false,
  // 暂不支持该属性
  disabled: false // 是否禁用
  // icon: null, // 菜单图标
  // title: '', // 设置收缩时展示的悬浮标题
  // attribute: {}, // 添加到dom上的属性

});

_defineProperty(MenuItem, "isMenuItem", true);

export { MenuItem as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-menu/src/MenuItem.js